import Resource from '@/api/resources/Resource'

class SampleTypeService extends Resource {
    async findSampleTypes() {
        return this.axios.get(`/common/sampleTypes`)
            .then(response => response.data)
    }

    async samplesTypeWithRelatedCaseTypesByIds(laboratoryId, sampleTypeIds) {
        const response = await this.axios.get(`/common/sampleTypes/withCaseTypes`, { params: {
            laboratoryId,
            sampleTypeIds
        } })
        return response.data
    }
}

export default new SampleTypeService()
